import React from 'react';
import { useSelector } from 'react-redux';

import { getAppointmentLivePersonProps } from 'features/order-tracker/store/selectors';
import { CHAT_BUTTON_PURPLE, SEND_MESSAGE_ANALYTICS } from "../LivePersonChat/constants";

import { LivePersonChat } from '../LivePersonChat';

import styles from './styles.module.scss';

export const AppointmentChatButton: React.FC<sharedComponents.AppointmentChatButton> = ({
  text,
  type = CHAT_BUTTON_PURPLE,
}) => {
  const livePersonDivId = useSelector(getAppointmentLivePersonProps);

  return (
    <>
      <LivePersonChat livePersonId={livePersonDivId} chatType={type} analytics={SEND_MESSAGE_ANALYTICS} />
      {!!text && <p className={styles.chatText}>{text}</p>}
    </>
  );
};
